import buildComponent from './utils/build-component';
import noScroll from 'no-scroll';

export default (nameSpace) => buildComponent({
  nameSpace,
  initFunction: ($el, params) => {
    let scrollTopCache = 0;

    //
    // Methods
    //

    function hide() {
      if (!$el) return $el;
      $el.classList.add(`${nameSpace}--is-hidden`);
      noScroll.off()
      document.documentElement.scrollTop = scrollTopCache;
      document.body.scrollTop = scrollTopCache;
    }

    function show() {
      if (!$el) return $el;
      scrollTopCache = (document.documentElement.scrollTop || document.body.scrollTop)
      $el.classList.remove(`${nameSpace}--is-hidden`);
      $el.classList.remove(`${nameSpace}--is-success`);
      noScroll.on()
    }

    function success() {
      if (!$el) return $el;
      $el.classList.add(`${nameSpace}--is-success`);
    }

    //
    // Public API
    //
    return {
      show,
      hide,
      success,
    };
  },
});


// WEBPACK FOOTER //
// ./src/scripts/loading-overlay.js